// extracted by mini-css-extract-plugin
export default {"errorContainer":"ErrorModal_errorContainer__OaEs6","errorImage":"ErrorModal_errorImage__jzorH","errorText":"ErrorModal_errorText__dK1M9"};